import { render, staticRenderFns } from "./StartForm7.vue?vue&type=template&id=55fc8f2f&scoped=true"
import script from "./StartForm7.vue?vue&type=script&lang=ts"
export * from "./StartForm7.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc8f2f",
  null
  
)

export default component.exports